import { RequestQuotationClientRequest } from '../../../@types/RequestQuotation'
import { useSimulatorStore } from '../../../Stores/simulatorStore'
import { useCreateProposalStore } from '../../../Stores/useCreateProposalStore'
import { useDocumentStore } from '../../../Stores/useDocumentStore'
import { useFillDataForSimulationStore } from '../../../Stores/useFillDataForSimulationStore'
import { useQuotationStore } from '../../../Stores/useQuotationStore'
import { useRunPetisSimulationStore } from '../../../Stores/useRunPetisSimulationStore'
import { useSimulationSummaryDownloadStore } from '../../../Stores/useSimulationSummaryDownloadStore'
import { useSubmitPetsInfoStore } from '../../../Stores/useSubmitPetsInfoStore'

export const useRequestQuotationPayload = () => {
  const { createProposal } = useCreateProposalStore()
  const { runPetisSimulation } = useRunPetisSimulationStore()
  const { quotation } = useQuotationStore()
  const { submitPetsInfo } = useSubmitPetsInfoStore()
  const { quoteId } = useSimulatorStore()
  const { switchAttachment } = useDocumentStore()
  const { fillDataForSimulationRequest } = useFillDataForSimulationStore()
  const { simulationSummaryDownload } = useSimulationSummaryDownloadStore()

  const runPetis = runPetisSimulation?.runPetisSimulationResponse

  const useRequestQuotationPayload = (context: string) => {
    return {
      lineOfBusinessId:
        runPetis?.productData?.lineofBusiness?.lineofBusinessID || '',
      productFamilyId:
        runPetis?.productData?.lineofBusiness?.productFamilyID || '',
      productTypeId: runPetis?.productData?.lineofBusiness?.productTypeID || '',
      productCode: runPetis?.productData?.productCode || '',
      segmentCode: runPetis?.productData?.segment?.segmentCode || '',
      policyId: createProposal?.createProposalResponse?.proposalId || '',
      agentObservations: quotation?.agentObservations || '',
      conditionDetails: quotation?.conditionDetails || '',
      otherRiskFactors: quotation?.otherRiskFactors || '',
      commercialStudy: quotation?.commercialStudy || '',
      relatedEntityNIF: quotation?.relatedEntityNIF || '',
      quoteId: submitPetsInfo?.quoteId || quoteId || '',
      hasSimulationDocumentGenerated: Boolean(simulationSummaryDownload),
      createdBy:
        fillDataForSimulationRequest?.agentDetailsResponse?.agentName || '',
      attachments: switchAttachment[context]
        ? quotation?.attachments?.map((item) => {
            return {
              documentContent: item.documentContent || '',
              documentName: item.documentName || '',
              documentType: item.documentType || '',
            }
          })
        : [],
    } as RequestQuotationClientRequest
  }

  return useRequestQuotationPayload
}
